<template>
  <div id="app">
    <div class="container">
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="css">
@import "./assets/css/global.css";
</style>
